module.exports = __webpack_public_path__ + "img/tab_icon_seach2.1766306608134.png";